const festivaldetailsData = {
  "దసరా వివరణ": [
    {
      "CatID": [
        {
          "title": "నవరాత్రుల్లో మొదటిరోజు అమ్మవారు త్రిశూల ధారిణి అయిన హిమవంతుని కుమార్తె శైలపుత్రి స్వర్ణకవచాలంకృత దుర్గాదేవిగా భక్తులకు దర్శనమిస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "శైలం అంటే కొండ. పర్వతమైన హిమవంతునికి జన్మించిన అమ్మవారు కాబట్టీ శైలపుత్రి అని పేరు వచ్చింది."
        },
        {
          "title": ""
        },
        {
          "title": "సతీ, భవానీ, పార్వతి, హేమవతి అనే పేర్లు అమ్మవారికి కూడా ఉన్నాయి. అమ్మవారి తలపై చంద్రవంక ఉంటుంది. కుడిచేతిలో త్రిశూలం, ఎడమ చేతిలో కమలం ఉన్న ఈ అమ్మవారి వాహనం వృషభం."
        },
        {
          "title": ""
        },
        {
          "title": "మహిషాసురుని సంహరించేందుకు యుద్ధంలో మొదటిరోజు పరాశక్తి ఇలా పార్వతీదేవిగా వచ్చింది. కాబట్టే నవరాత్రుల మొదటిరోజు శైలపుత్రీగా దుర్గాదేవిని ఆరాధిస్తారు."
        },
        {
          "title": ""
        },
        {
          "title": "శైలపుత్రీదేవికి పాడ్యమి రోజు విశేషంగా సమర్పించే నైవేద్యం పులగం, చెక్కెర పొంగలి. తొలి రోజు భక్తిశ్రద్ధలతో అమ్మను పూజించి పులగం, చెక్కెర పొంగలిని నివేదించిన వారికి ఆ తల్లి సకల శక్తి సామర్థ్యాలనూ, యశస్సునూ అందిస్తుంది. బంగారు రంగు చీరను వస్త్రముగాను సమర్పించాలి."
        },
      ],
      // "Path": require('../../Utils/Festivals/DussehraFest/Sailaputridevi.png'),
      "title": "శైలపుత్రి",
      "batumakammaTitle": "(ఎంగిలిపూల బతుకమ్మ)"
    },
    {
      "CatID": [
        {
          "title": "రెండవ రోజు పరాశక్తి బాలాత్రిపుర సుందరీదేవి అలంకారంలో భక్తులకు దర్శనమిస్తుంది. త్రిపుర సుందరీదేవి శ్రీ చక్రంలోని త్రిపురాత్రయంలో మొదటి దేవత. షోడశ విద్యకు అధిష్టాన దేవత. అందుకే ఉపాసకులు త్రిపురసుందరీదేవి అనుగ్రహం కోసం బాలార్చన చేస్తారు. అందుకే ఈ రోజున రెండు నుంచి పదేళ్లలోపు బాలికలను అమ్మవారి స్వరూపంగా భావించి కుమారి పూజచేస్తారు. త్రిశతీ పారాయణం గావిస్తారు. మనస్సు, బుద్ధి, చిత్తం, అహంకారం త్రిపుర సుందరీదేవి అధీనంలో ఉంటాయి. సత్సంతానాన్ని అనుగ్రహిస్తుంది. అభయహస్త ముద్రతో, అక్షమాల ధరించిన జగన్మాతను ఆరాధిస్తే మనోవికారాలు తొలిగిపోతాయి. లేత గులాబీ రంగు చీరను వస్త్రముగాను, కట్టె పొంగలిని నైవేద్యముగాను సమర్పించాలి."
        }
      ],
      // "Path": require('../../Utils/Festivals/DussehraFest/Balatripurasundari.png'),
      "title": "బాలాత్రిపురసుందరీ దేవి",
      "batumakammaTitle": "(అటుకుల బతుకమ్మ)"
    },
    {
      "CatID": [
        {
          "title": "వేద స్వరూపం గాయత్రీదేవి. అన్ని మంత్రాలకు మూలశక్తి గాయత్రీ మంత్రం. మూడో రోజు ముక్త, విద్రుమ, హేమ, నీల, ధవళ వర్ణాలు కలిగిన ఐదు ముఖాలతో శంఖం, చక్రం, గద, అంకుశం ధరించి దర్శనమిస్తుంది. గాయత్రీ ఉపాసానతో మంత్రసిద్ధి, బ్రహ్మ జ్ఞానం కలుగుతాయి. గాయత్రీ మంత్ర జపంతో చతుర్వేద పారాయణ ఫలితం లభిస్తుంది."
        },
        {
          "title": ""
        },
        {
          "title": "‘ఓం భూర్భువస్వః తత్సవితుర్వరేణ్యం భర్గో దేవస్య ధీమహి ధియోయోనః ప్రచోదయాత్‌’ అనే మంత్రాన్ని జపిస్తూ అమ్మను ధ్యానించాలి."
        },
        {
          "title": ""
        },
        {
          "title": "నారింజ రంగు చీరను వస్త్రముగాను, పులిహోరని నైవేద్యముగాను సమర్పించాలి."
        }
      ],
      // "Path": require('../../Utils/Festivals/DussehraFest/Gayatridevi.png'),
      "title": "గాయత్రీ దేవి",
      "batumakammaTitle": "(ముద్దపప్పు బతుకమ్మ)"
    },
    {
      "CatID": [
        {
          "title": "త్రిపురాత్రయంలో లలితాదేవి రెండో శక్తి. దేవీ ఉపాసకులకు ముఖ్యదేవత. త్రిగుణాతీతమైన కామేశ్వర స్వరూపంలో నాలుగవ రోజున దర్శనమిస్తుంది. లక్ష్మీ సరస్వతులు ఇరువైపులా నిలబడి వింజామరలు వీస్తుండగా శ్రీచక్ర అధిష్ఠాన శక్తిగా కొలువుదీరుతుంది. చెరుకుగడ, విల్లు, పాశాంకుశాలను ధరించి భక్తులకు వరాలిస్తుంది. లలితాదేవి విద్యా స్వరూపిణి. మాంగల్య సౌభాగ్యాన్ని ప్రసాదిస్తుంది. దేవి అనుగ్రహం కోసం సువాసినీ పూజ చేయాలి. సమస్త సుఖాలు ప్రసాదించే శక్తి స్వరూపిణి లలితాదేవి. బంగారు రంగు జరీ చీరను వస్త్రముగాను, అల్లం గారెలని నైవేద్యముగాను సమర్పించాలి."
        }
      ],
      // "Path": require('../../Utils/Festivals/DussehraFest/Lalithadevi.png'),
      "title": "లలితా దేవి",
      "batumakammaTitle": "(నాన బియ్యం బతుకమ్మ)"
    },
    {
      "CatID": [
        {
          "title": "శరన్నవరాత్రుల్లో మూలా నక్షత్రానికి చాలా విశిష్టత ఉంది. జగన్మాత చదువుల తల్లి సరస్వతీ రూపంలో దర్శనమిచ్చే రోజు. బ్రహ్మ చైతన్య స్వరూపిణిగా సరస్వతీని పురాణాలు అభివర్ణించాయి. శ్వేతపద్మాన్ని ఆసనంగా అధిష్టించి, వీణ, దండ, కమండలం, అక్షమాల ధరించి, అభయముద్రతో భక్తుల అజ్ఞాన తిమిరాలను దూరం చేస్తుంది. త్రిశక్తి రూపాల్లో సరస్వతి మూడో శక్తి రూపం. సంగీత సాహిత్యాలకు అధిష్టాన దేవత. ఈ తల్లిని ఆరాధించడం వల్ల బుద్ధి వికాసం, విద్యాలాభం కలుగుతాయి. తెలుపు రంగు చీరను వస్త్రముగాను, దద్ధోజనముని నైవేద్యముగాను సమర్పించాలి."
        }
      ],
      // "Path": require('../../Utils/Festivals/DussehraFest/Saraswathidevi.png'),
      "title": "సరస్వతీ దేవి",
      "batumakammaTitle": "(అట్ల బియ్యం బతుకమ్మ)"
    },
    {
      "CatID": [
        {
          "title": "ఆరవ రోజు అమ్మవారిని అన్నపూర్ణాదేవిగా అలంకరిస్తారు. ప్రాణికోటికి జీవనాధారం అన్నం. అందుకే అన్నం పరబ్రహ్మ స్వరూపం అంటారు. సాక్షాత్తు పరమేశ్వరుడికే భిక్షపెట్టిన దేవత అన్నపూర్ణాదేవి. ఈ తల్లిని ధ్యానిస్తే ధనధాన్యవృద్ధి, ఐశ్వర్య సిద్ధి కలుగుతాయి. అన్నపూర్ణాదేవి ధరించిన రసపాత్ర అక్షయ శుభాలను అందిస్తుంది. గంధపు పసుపు రంగు చీరను వస్త్రముగాను, కొబ్బరి అన్నముని నైవేద్యముగాను సమర్పించాలి."
        }
      ],
      // "Path": require('../../Utils/Festivals/DussehraFest/Annapurnadevi.png'),
      "title": "అన్నపూర్ణా దేవి",
      "batumakammaTitle": "(అలిగిన బతుకమ్మ)"
    },
    {
      "CatID": [
        {
          "title": "రెండు చేతులలో మాలలను ధరించి, అభయవరద హస్త ముద్రలను ప్రదర్శిస్తూ, గజరాజు సేవిస్తుండగా శ్రీమహాలక్ష్మిీ రూపంలో అమ్మవారు దర్శనమిస్తారు. మహాలక్ష్మీ సర్వమంగళకారిణి, ఐశ్వర్యప్రదాయిని. అష్టలక్ష్ముల సమష్టి రూపమే మహాలక్ష్మీ. డోలాసురుడు అనే రాక్షసుడిని వధించింది. శక్తి త్రయంలో మధ్య శక్తి. మహాలక్ష్మీని ఉపాసిస్తే ఫలితాలు త్వరితంగా కలుగుతాయి. యాదేవీ సర్వభూతేషు లక్ష్మీరూపేణ సంస్థితా అంటే అన్ని జీవలలోనూ ఉండే లక్ష్మీస్వరూపం దుర్గాదేవని చండీసప్తసతి చెబుతోంది. శరన్నవరాత్రులలో మహాలక్ష్మిని పూజిస్తే సర్వ మంగళ మాంగల్యాలు కలుగుతాయి."
        },
        {
          "title": "గులాబి రంగు చీరను వస్త్రముగాను, రవ్వ కేసరిని నైవేద్యముగాను సమర్పించాలి."
        }
      ],
      // "Path": require('../../Utils/Festivals/DussehraFest/Mahalakshmidevi.png'),
      "title": "మహాలక్ష్మీ",
      "batumakammaTitle": "(వేపకాయ బతుకమ్మ)"
    },
    {
      "CatID": [
        {
          "title": "దుర్గతులను నివారించే పరాశక్తి దుర్గాదేవిగా దర్శనమిస్తుంది. ఈ రోజునే దుర్గాష్టమి. ఈ అవతారంలో దుర్గముడనే రాక్షసుడిని అమ్మవారు సంహరించినట్లు పురాణాలు చెబుతున్నాయి. పంచ ప్రకృతి మహాస్వరూపాల్లో మొదటిది దుర్గారూపం. భవబంధాలలో చిక్కుకున్న మానవుడిని అనుగ్రహించి మోక్షాన్ని ప్రసాదించే మాత. కోటి సూర్యప్రభలతో వెలిగొందే అమ్మను అర్చిస్తే శత్రుపీడనం తొలగిపోతుంది. సర్వత్రా విజయం ప్రాప్తిస్తుంది. ఎర్రని వస్త్రం సమర్పించి, ఎర్రటి అక్షతలు, ఎర్రటి పుష్పాలతో అమ్మను పూజించాలి. కదంబం నివేదనగా సమర్పించాలి."
        }
      ],
      // "Path": require('../../Utils/Festivals/DussehraFest/Durgadevi.png'),
      "title": "దుర్గా దేవి",
      "batumakammaTitle": "(వెన్నముద్దల బతుకమ్మ)"
    },
    {
      "CatID": [
        {
          "title": "నవ అవతారాల్లో మహిషాసురమర్ధినిని మహోగ్రరూపంగా భావిస్తారు. మహిషాసురుని సంహరించిన అశ్వయుజ శుద్ధ నవమిని ‘మహర్నవమి’గా జరుపుకుంటారు. సింహవాహనాన్ని అధిష్టించి ఆయుధాలను ధరించిన చండీ సకల దేవతల అంశలతో మహాశక్తి స్వరూపంగా దర్శనమిస్తుంది. ఈ తల్లిని పూజిస్తే సకల దేవతల అనుగ్రహం కలుగుతుంది. మహిషాసురమర్ధిని ఆరాధన వల్ల భయాలన్నీ తొలగిపోతాయి. సర్వకార్యాల్లో విజయం సిద్ధిస్తుంది. బ్రౌన్ / ఎరుపు కలనేత జరీ చీరను వస్త్రముగాను, బెల్లం పరమాన్నముని నైవేద్యముగాను సమర్పించాలి."
        }
      ],
      // "Path": require('../../Utils/Festivals/DussehraFest/Mahishasuramardini.png'),
      "title": "మహిషాసురమర్ధిని",
      "batumakammaTitle": "(సద్దుల బతుకమ్మ)"
    },
    {
      "CatID": [
        {
          "title": "శరన్నవరాత్రుల్లో అమ్మవారి చివరి అలంకారం రాజరాజేశ్వరీదేవి. ఈ రోజునే దసరా పండగ (విజయదశమి) జరుపుకుంటాము. భువన బ్రహ్మాండాలకు ఆరాధ్య దేవత. మహాత్రిపుర సుందరిగా పూజలు అందుకుంటుంది. ‘అపరాజితాదేవి’గా భక్తులు ఆరాధిస్తారు. పరమేశ్వరుడి అంకం ఆసనంగా, ఇచ్ఛా, జ్ఞాన, క్రియా శక్తులను భక్తులకు అనుగ్రహిస్తుందీ తల్లి. యోగమూర్తిగా మాయామోహిత మానవ చైతన్యాన్ని ఉద్దీపనం చేస్తుంది. అనంత శక్తి స్వరూపమైన శ్రీ చక్రానికి ఈ తల్లి అధిష్టాన దేవత. లలితా సహస్రనామ పారాయణం, కుంకుమార్చన చేయాలి. ఆకుపచ్చ రంగు చీరను వస్త్రముగాను, షడ్రసోపేతమైన నైవేద్యాలు లేదా పూర్ణము,బూరెలు,పరమాన్నముని నైవేద్యముగాను సమర్పించాలి."
        }
      ],
      // "Path": require('../../Utils/Festivals/DussehraFest/Rajarajeswaridevi.png'),
      "title": "రాజరాజేశ్వరీ దేవి",
      "batumakammaTitle": " దసరా శుభాకాంక్షలు "
    },
    {
      "CatID": [
        {
          "title": "హిందువులకు అత్యంత ముఖ్యమైన పండగ విజయదశమి. దీన్ని దేశవ్యాప్తంగా ప్రజలందరూ అంగరంగ వైభవంగా జరుపుకుంటారు. ఇది ముఖ్యముగా శక్తి ఆరాధనకు ప్రాధాన్యత ఇచ్చే పండుగ."
        },
        {
          "title": ""
        },
        {
          "title": "చెడు మీద మంచిని సాధించిన విజయానికి గుర్తుగా ఈ పండుగను విజయదశమి అని పిలుస్తారు. మనిషి తనలోని కామ, క్రోద, మోహ, లోభ, మధ, మత్సర, స్వార్ధ, అన్యాయ, అహంకార అనే దుర్గుణాలను తొలగించుకొనుటకు ఆధ్యాత్మికంగా ఈ శరన్నవరాత్రులలో అమ్మ వారికి శరణుజొచ్చడమే ఉత్తమమైన మార్గం."
        },
        {
          "title": ""
        },
        {
          "title": "జగన్మాత అయిన దుర్గా దేవి, మహిషాసురుడనే రాక్షసునితో తొమ్మిది రోజులు యుద్ధము చేసి అతనిని వధించి విజయాన్ని పొందిన సందర్భమున 10వ రోజు ప్రజలంతా సంతోషముతో దసర పండగను జరుపుకుంటారు."
        },
        {
          "title": ""
        },
        {
          "title": "ఏదైనా కొత్త పనిని ప్రారంభించాలనుకొనేవారు ఈ రోజు ప్రారంభిస్తే విశేష ఫలితం లభిస్తుంది. శమీ వృక్షం (జమ్మి చెట్టు) యొక్క పూజ ఈ రోజు విశేష ఫలితం లభిస్తుంది. శమి అంటే పాపాల్ని, శత్రువుల్ని నశింపజేసేది. జమ్మి చెట్టును పూజించడం లక్ష్మీప్రదమని పురాణాలు చెబుతున్నాయి. శమీ వృక్షం సువర్ణ (కనక) వర్షం కురిపిస్తుందని శాస్త్రాల్లో ఉంది."
        },
        {
          "title": ""
        },
        {
          "title": "పంచ పాండవులు అజ్ఞాత వాసానికి వెళ్ళే ముందు తమ ఆయుధాలని శమీ చెట్టుపై పెట్టడం జరిగింది. ఈ విజయదశమి రోజున ఆయుధ పూజ, పార్వేట కూడా నిర్వహిస్తారు. విజయదశమి రోజున పూజలు అందుకొన్న జమ్మి చెట్టు ఆకులను ఇంట్లోని పూజా స్థలంలోను, ధన స్థానంలోను, నగదు గల్ల పెట్టెల్లో పెట్టుకుంటారు. దీనివల్ల ధనవృద్ది జరుగుతుంది."
        },
        {
          "title": ""
        },
        {
          "title": "తొమ్మిది రోజులు నవ దుర్గలను నిష్ఠగా ఉపాసించే ఆరాధకులకు దేవి అనుగ్రహం లభిస్తుంది. నవరాత్రులలో రాహుకాల వేళ రాహుకాల దీపం వెలిగించాలి. రాహు ప్రతికూల ప్రభావం తగ్గి, దోష నివారణ జరుగుతుంది. దేవి అర్చనలో లలితా సహస్రనామాలు, దుర్గాసప్తశతి పారాయణ చేసే భక్తుల కోరికలు నెరవేరుతాయి. రోగ పీడలతో బాధపడే వారు, జాతకంలో అపమృత్యు దోషం ఉన్నవారు ఈ తొమ్మిది రోజులు నియమం తప్పకుండా దేవి ఆరాధన చేయడం శుభకరం."
        },
        {
          "title": ""
        },
        {
          "title": "సామాన్యులే గాక యోగులు నవరాత్రులలో అమ్మవారిని పూజిస్తారు. ఆలయాలలో అమ్మవారికి విశేష అలంకరణలు, బొమ్మల కొలువు పెట్టడం ఒక ఆనవాయితీ. ఈ తొమ్మిది రోజులు ఒక్కో రోజు ఒక్కో అలంకారం చేసి పూజిస్తారు. అమ్మవారు లోక కళ్యాణం కోసం ఒక్కోరోజు ఒక్కో అవతారం ధరించింది. అందువలన అలా అమ్మవారు అవతరించిన రోజున ఆ రూపంతో అమ్మవారిని అలంకరించి ఆ నామంతో ఆరాధిస్తూ ఉంటారు."
        },
        {
          "title": ""
        },
        {
          "title": "నవరాత్రులుగా పిలవబడే ఈ 9 పర్వదినాల్లో అమ్మవారిని అత్యంత భక్తిశ్రద్ధలతో పూజిస్తారు. ఈ 9 రోజులు 9 అవతారాల్లో అమ్మవారిని అలంకరిస్తారు."
        },
      ],
      // "Path": require('../../Utils/Festivals/DussehraFest/Pramukyata.png'),
      "title": "దసరా శరన్నవరాత్రుల ప్రాముఖ్యత",
      "batumakammaTitle": ""
    },
  ],
  'vinayakavratam': {
    "CatID": [
      {
        "title": "వినాయక వ్రత కథ చదివేవారు, పూజలో కూర్చునేవారు, కధని ఆలకించేవారు ముందు చేతిలో కొద్దిగా అక్షింతలు తీసుకోవాలి. కథ పూర్తయిన తర్వాత కొన్ని అక్షింతలు విఘ్నేశ్వరుని పాదముల దగ్గర ఉంచి మరికొన్ని అక్షింతలు తమ శిరస్సుపై ఉంచుకోవాలి."
      },
      {
        "title": ""
      },
      {
        "title": <span classname="highlight">వినాయక వ్రత కథ ప్రారంభము :</span>
      },
      {
        "title": ""
      },
      {
        "title": "పూర్వం చంద్రవంశానికి చెందిన ధర్మరాజు దాయాదుల వల్ల రాజ్యాన్ని, సిరిసంపదలన్నీ పోగొట్టుకున్నాడు. భార్య, తమ్ములతో వనవాసం చేస్తూ ఒకనాడు నైమిశారణ్యానికి చేరుకున్నాడు. అక్కడ శౌనకాది ఋషులకు అనేక పురాణ రహస్యాలను బోధిస్తున్న సూతమహామునిని దర్శించి ఋషివర్యా, మేము రాజ్యాధికారాన్నీ సమస్త వస్తు వాహనాలనూ పోగొట్టుకున్నాము. ఈ కష్టాలన్నీ తీరి, పూర్వవైభవం పొందేలా ఏదైనా సులభమైన వ్రతాన్ని చెప్పండి అని ప్రార్థించాడు. అప్పుడు సూతమహాముని ధర్మరాజుకు వినాయకవ్రతం చేస్తే కష్టాలు తొలగిపోయి, సమస్త సౌఖ్యాలూ కలుగుతాయి అంటూ ఇలా చెప్పసాగాడు."
      },
      {
        "title": ""
      },
      {
        "title": "ఒకసారి కుమారస్వామి పరమశివుణ్ణి దర్శించి తండ్రీ! మానవులు ఏ వ్రతం చేయడం వలన వంశాభివృద్ధిని పొంది, సమస్త కోరికలూ తీరి, సకల శుభాలనూ, విజయాలనూ, వైభవాలనూ పొందగలుగుతారో అటువంటి వ్రతాన్ని చెప్పండి అని కోరాడు. అందుకు శివుడు ‘నాయనా! సర్వసంపత్కరం, ఉత్తమమైన వినాయక వ్రతము అనేది ఒకటుంది. దీన్ని భాద్రపద శుద్ధ చవితినాడు ఆచరించాలి."
      },
      {
        "title": ""
      },
      {
        "title": "ఆ పర్వదినము రోజున ఉదయాన్నే నిద్రలేచి ఇంటిని శుభ్రపరచుకొని, తలంటు స్నానం చేసి ఉతికిన వస్త్రాలు ధరించి మామిడి తోరణములతో ఇంటిని అలంకరించాలి. ఆ తర్వాత పాలవెల్లికి పసుపు రాసి, కుంకుమ బొట్టు పెట్టి దానిని పండ్లతో, మొక్కజొన్న పొత్తులతో గాని అలంకరించాలి."
      },
      {
        "title": ""
      },
      {
        "title": "పాలవెల్లికి మధ్యలో ఉండే విధంగా తమ శక్తిమేరకు బంగారంతోగానీ, వెండితోగానీ లేదా మట్టితోగానీ తయారు చేసిన వినాయకుని ప్రతిమను ప్రతిష్టించి స్వామివారిని గరిక (లేదా) 21 రకాల పత్రాలతోనూ పూజించి, వ్రతకధ చెప్పుకొని ఉండ్రాళ్ళు, మొదలైన పదార్ధాలను నైవేద్యంగా సమర్పించవలెను. నృత్య, గీత, వాద్య పురాణ పఠనాదులతో పూజను ముగించి, యథాశక్తి వేదవిదులైన బ్రాహ్మణులకి దక్షిణ, తాంబూలాదులు ఇవ్వాలి."
      },
      {
        "title": ""
      },
      {
        "title": "బంధుజనంతో కలిసి భక్ష్య భోజ్యాదులతో భోజనం చేయాలి. మరుసటిరోజు ఉదయం స్నానసంధ్యలు పూర్తిచేసుకుని గణపతికి పునఃపూజ చేయాలి. ఈ విధంగా ఎవరైతే వినాయక వ్రతాన్ని చేస్తారో వాళ్ళకి గణపతి ప్రసాదం వలన సకల కార్యాలూ సిద్ధిస్తాయి."
      },
      {
        "title": ""
      },
      {
        "title": "అన్ని వ్రతాల్లోకీ అత్యుత్తమమైన ఈ వ్రతం త్రిలోక ప్రసిద్ధమై దేవ, ముని, గంధర్వాదులందరిచేతా ఆచరింపబడింది అని పరమశివుడు కుమారస్వామికి చెప్పాడు."
      },
      {
        "title": ""
      },
      {
        "title": "కనుక ధర్మరాజా! నువ్వు కూడా ఈ వ్రతాన్ని ఆచరించినట్లయితే నీ శత్రువులను జయించి సమస్త సుఖాలనూ పొందుతావు. గతంలో విదర్భ యువరాణి దమయంతి ఈ వ్రతం చేయడం వల్లనే తాను ప్రేమించిన నలమహారాజును పెళ్లాడ గలిగింది. శ్రీకృష్ణుడంతటివాడు ఈ వ్రతం చేయడం వల్లనే శమంతకమణితోబాటుగా జాంబవతీ, సత్యభామలనే ఇద్దరు కన్యామణులను కూడా పొందగలిగాడు. ఆ కథ చెబుతాను విను అంటూ ఇలా చెప్పసాగాడు."
      },
      {
        "title": ""
      },
      {
        "title": "పూర్వం గజాసురుడు శివుడి కోసం తపస్సు చేశాడు. అతని తపస్సునకు మెచ్చి పరమేశ్వరుడు ప్రత్యక్షమై వరం కోరుకోమన్నాడు. గజాసురుడు స్వామీ నువ్వు నా ఉదరమందే నివసించాలి అని కోరాడు. దాంతో భక్తసులభుడైన శివుడు అతడి ఉదరమందే ఉండిపోయాడు. జగన్మాత పార్వతీదేవి భర్తను వెదుకుతూ ఆయన గజాసురుని గర్భములో ఉన్నాడని తెలిసి, ఆయన్ను దక్కించుకునే ఉపాయం కోసం శ్రీమహావిష్ణువును ప్రార్థించినది. శ్రీహరి బ్రహ్మాది దేవతలను పిలిపించి గజాసుర సంహారానికి గంగిరెద్దు మేళమే తగినదని నిర్ణయించి, నందీశ్వరుణ్ణి గంగిరెద్దుగా అలంకరించారు. బ్రహ్మాది దేవతలందరూ తలొక వాయిద్యాన్ని ధరించారు. మహావిష్ణువు చిరుగంటలు, సన్నాయిలు ధరించాడు. గజాసుర పురానికి వెళ్ళి గంగిరెద్దును ఆడిస్తుండగా గజాసురుడది విని, వారిని పిలిపించి తన భవనం ఎదుట గంగిరెద్దును ఆడించమని కోరాడు. బ్రహ్మాది దేవతలు వాద్యాలను వాయిస్తుండగా జగన్నాటక సూత్రధారియైన హరి చిత్రవిచిత్రంగా గంగిరెద్దును ఆడించాడు."
      },
      {
        "title": ""
      },
      {
        "title": "గజాసురుడు పరమానందభరితుడై ఏమి కావాలో కోరుకోమన్నాడు. అంతట శ్రీహరి గజాసురుణ్ణి సమీపించి ఇది శివుని వాహనమైన నంది, శివుణ్ణి కనుగొనడానికి వచ్చింది, శివుణ్ణి అప్పగించు’ అని కోరాడు. ఆ మాటలకు గజాసురుడు నివ్వెరపోయి, వచ్చినవాడు రాక్షసాంతకుడైన శ్రీహరి అని తెలుసుకొని, తనకు మరణమే నిశ్చయమనుకున్నాడు. తన గర్భంలో ఉన్న పరమేశ్వరుణ్ణి ఉద్దేశించి స్వామీ, నా శిరస్సును త్రిలోక పూజ్యముగా చేసి, నా చర్మాన్ని నువ్వు ధరించు అని ప్రార్థించాడు. తన గర్భంలో ఉన్న శివుణ్ణి తీసుకోవచ్చునని విష్ణుమూర్తికి అంగీకారం తెలియజేశాడు. అంత శ్రీహరి నందిని ప్రేరేపించగా, నంది తన కొమ్ములతో గజాసురుని ఉదరాన్ని చీల్చాడు. బ్రహ్మాది దేవతలకు వీడ్కోలు చెప్పి శ్రీహరి వైకుంఠానికి వెళ్ళగా, శివుడు నందినెక్కి కైలాసానికి వెళ్లాడు."
      },
      {
        "title": ""
      },
      {
        "title": "తన భక్తుడైన గజాసురుని కోరిక మేరకు అతడి ఉదరంలో ఉన్న పరమేశ్వరుని శ్రీమహావిష్ణువు విముక్తి కల్పించడంతో భర్త రాకకు పార్వతి కైలాసంలో ఎదురుచూస్తోంది. శివుడి కోసం ఎదురు చూస్తూ స్నానానికి సిద్ధమైంది. స్నానానికి వెళుతూ దేహానికి నలుగుపిండిని అద్దుకుంది. పరధ్యానంలో ఆ పిండితోనే ఓ ప్రతిమను తయారుచేసింది. చూడముచ్చటైన ఆ బాలుడికి తండ్రి ఉపదేశించిన మంత్ర సాయంతో పార్వతి ప్రాణం ప్రతిష్ఠ చేసింది."
      },
      {
        "title": ""
      },
      {
        "title": "సుందరమైన ఆ బాలుని వాకిట కాపలా ఉంచి తాను స్నానానికి వెళ్లింది. అంతలో అక్కడికి వచ్చిన శివుడిని ఆ బాలుడు అడ్డుకున్నాడు. ఆగ్రహావేశాలకు లోనైన రుద్రుడు ఆ బాలుడి శిరస్సును తన త్రిశూలంతో ఖండించాడు. ఆ శబ్దానికి బయటికి వచ్చిన పార్వతీ దేవి, జరిగిన ఘోరం చూసి కన్నీళ్లు పెట్టుకుంది. దీంతో శివుడు గజముఖుడి శిరస్సును తెప్పించి ఆ బాలుడికి అతికించి ప్రాణం పోసి గజాననుడు అనే నామకరణం చేశాడు. అతడి శక్తి సామర్ధ్యాలను పరిశీలించి భాద్రపద శుద్ధ చవితి నాడు గణాధిపత్యాన్ని ఇచ్చారు. ఆ రోజున తనకు భక్తితో సమర్పించిన ఉండ్రాళ్లు, కుడుములు, పిండివంటలు, పండ్లను సుష్టిగా తిన్న వినాయకుడి నడవటానికి ఇబ్బందిపడుతూ కైలాసం చేరుకున్నాడు."
      },
      {
        "title": ""
      },
      {
        "title": "శివుని శిరస్సుపై ఉన్న చంద్రుడు గణనాధుని అవస్థలు చూసి పక్కున నవ్వాడు. రాజ‌దృష్టి సోకితే రాళ్లు కూడా నుజ్జవుతాయని విఘ్ననాధుని ఉదరం పగిలి అందులోని ఉండ్రాళ్లు, కుడుములు బయటకు వచ్చి అచేతనుడయ్యాడు. దీంతో ఆగ్రహించిన పార్వతి దేవి, పాపాత్ముడా నీ దృష్టిసోకి నా కుమారుడు అచేతనంగా పడివున్నాడు కాన నిన్నుచూసివారు పాపాత్ములై నీలాపనిందలు పొందుదురు గాక అని శపించింది."
      },
      {
        "title": ""
      },
      {
        "title": <span classname="highlight">ఋషి పత్నులకు నీలాపనిందలు :</span>
      },
      {
        "title": ""
      },
      {
        "title": "పార్వతీదేవి చంద్రుని శపించిన సమయంలో సప్తఋషులు భార్యలతో కలసి యజ్ఞం చేస్తూ, అగ్నిదేవునికి ప్రదక్షిణం చేస్తున్నారు. అగ్నిదేవుడికి ఋషిపత్నుల మీద మోహం కలిగింది. కోరిక తీరక, శపిస్తారేమో అనే భయంతో అగ్ని క్షీణింపసాగాడు. భర్త కోరిక తెలుసుకున్న స్వాహాదేవి ఋషుల భార్యల రూపంలో అగ్నిదేవుడిని చేరింది. అగ్నిదేవునితో ఉన్నది తమ భార్యలేనని భ్రాంతి చెందిన ఋషులు, వారిని విడిచిపెట్టారు. శాపగ్రస్థుడైన చంద్రుని చూడటం వల్లనే ఋషుల భార్యలు నీలాపనిందలకు గురయ్యారని దేవతలు గ్రహించారు. దేవతలందరూ బ్రహ్మదేవునితో కలసి కైలాసానికి వెళ్లారు. మరణించిన విఘ్నేశ్వరుడిని బ్రహ్మదేవుడు తిరిగి బతికించాడు."
      },
      {
        "title": ""
      },
      {
        "title": "తర్వాత పార్వ‌తీదేవితో అమ్మా నీవు చంద్రునికి ఇచ్చిన శాపం వలన ఆపద కలిగింది. కావున శాపాన్ని ఉపసంహరించుకో అని కోరాడు. అప్పుడు పార్వతీదేవి ఏ రోజున చంద్రుడు విఘ్నేశ్వరున్ని చూసి నవ్వాడో ఆ రోజు చంద్రుణ్ణి చూడకూడదు అని శాపాన్ని సవరించింది. ఆ రోజునుంచి అందరూ భాద్రపద శుద్ధ చవితి నాడు చంద్రుణ్ణి చూడకుండా జాగ్రత్తగా ఉండి, సుఖంగా ఉన్నారు. ఇలా కొంతకాలం గడిచింది."
      },
      {
        "title": ""
      },
      {
        "title": <span classname="highlight">శమంతకోపాఖ్యానం :</span>
      },
      {
        "title": ""
      },
      {
        "title": "ద్వాపరయుగంలో ద్వారకలో నివాసం ఉన్న శ్రీకృష్ణుడిని నారదుడు కలిశాడు. కాసేపు  ముచ్చటించాక స్వామీ! ఈ రోజు వినాయక చవితి, పార్వతి శాపం కారణంగా చంద్రుని చూడరాదు అని కృష్ణుడికి చెప్పి నారదుడు వెళ్లిపోయాడు. ఆ రోజు రాత్రి ఎవ్వరూ చంద్రుణ్ణి చూడకూడదని పట్టణంలో శ్రీకృష్ణుడు చాటింపు వేయించాడు. శ్రీకృష్ణుడికి పాలంటే ఇష్టం కావున ఆ రోజు రాత్రి శ్రీకృష్ణుడు ఆవు పాలను తాగుతుండగా పాత్రలోని పాలలో చవితి చంద్రుడి ప్రతిబింబాన్ని చూశాడు. దాంతో తనకెలాంటి అపనింద రానుందో అని చింతించాడు. కొన్ని రోజులు గడిచాయి. సత్రాజిత్తు సూర్యుని వరంతో శమంతకమణిని సంపాదించాడు."
      },
      {
        "title": ""
      },
      {
        "title": "రోజుకు పది బారువుల బంగారాన్ని ఇచ్చే ఆ మణిని తీసుకుని ద్వారకకు వెళ్లాడు. శ్రీకృష్ణుడు సత్రాజిత్తుకు అతిథి మర్యాదలు చేసి ఆ మణిని తనకు ఇవ్వమని కోరాడు. అందుకు సత్రాజిత్తు ఒప్పుకోలేదు. తర్వాత ఒక రోజు సత్రాజిత్తు తమ్ముడు ప్రసేనుడు శమంతకమణిని మెడలో వేసుకుని అడవికి వేటకు వెళ్లాడు. అడవిలో ఒక సింహం ఆ మణిని చూసి మాంసం ముక్క అనుకొని ప్రసేనుణ్ణి చంపింది. మణిని నోట కరచుకుని పోతూన్న సింహాన్ని జాంబవంతుడు చంపి, శమంతకమణిని కొండగుహలో ఉన్న తన కూతురు జాంబవతికి ఆట వస్తువుగా ఇచ్చాడు."
      },
      {
        "title": ""
      },
      {
        "title": "మరుసటి రోజు సత్రాజిత్తు తమ్ముడి మరణవార్త విన్నాడు. శ్రీకృష్ణుడే తన తమ్ముడిని చంపి శమంతకమణిని అపహరించాడని నిందించాడు. శ్రీకృష్ణుడు అది విన్నాడు. భాద్రపద శుద్ధ చవితి రోజు చంద్రబింబాన్ని చూసిన దోషంవల్ల తన మీద నింద పడిందనుకున్నాడు. శమంతకమణిని వెదుకుతూ అడవికి వెళ్లాడు. ఒక చోట ప్రసేనుడి శవం కనిపించింది. అక్కడి నుంచి సింహం అడుగులు కనిపించాయి."
      },
      {
        "title": ""
      },
      {
        "title": "అలా వెదుకుతూ వెళ్లి ఒక పర్వత గుహలోకి ప్రవేశించాడు. అందులో ఉన్న ఉయ్యాలకు కట్టిన మణిని చూసి, దానిని తీసుకుని బయటకు రాసాగాడు. వెంటనే జాంబవతి పెద్దగా ఏడ్వసాగింది. కూతురి ఏడుపు విని జాంబవంతుడు కోపంతో శ్రీకృష్ణుడిపై యుద్ధానికి తలపడ్డాడు. వారిద్దరి మధ్య ఇరవై ఎనిమిది రోజులు యుద్ధం జరిగింది. జాంబవంతుని శక్తి క్షిణించింది. తనతో యుద్ధం చేస్తున్నవాడు శ్రీరామచంద్రుడని గ్రహించి, త్రేతాయుగంలో జాంబవంతుడు శ్రీరాముడితో యుద్ధం చేయాలని కోరాడు. ఆ కోరికను ఇప్పుడు శ్రీకృష్ణుని రూపంలో వచ్చి తీర్చాడని గ్రహించి, శ్రీకృష్ణుడికి నమస్కరించి శమంతకమణితో పాటు తన కుమార్తె జాంబవతిని కూడా ఆయనకు సమర్పించాడు. శ్రీకృష్ణుడు శమంతకమణిని తెచ్చి సత్రాజిత్తుకు ఇచ్చాడు. నిజం తెలుసుకున్న సత్రాజిత్తు తనను క్షమించమని శ్రీకృష్ణుడిని వేడుకున్నాడు. తన కుమార్తె సత్యభామను ఇచ్చి వివాహం జరిపించాడు. శమంతకమణిని కూడా శ్రీకృష్ణుడికి ఇచ్చాడు."
      },
      {
        "title": ""
      },
      {
        "title": "ఆ సమయంలో అక్కడకు వచ్చిన మునులు శ్రీకృష్ణుడితో మీరు సమర్థులు కనుక మీపై పడిన నిందను పోగొట్టుకోగలిగారు, మావంటి వారికి ఏది గతి అన్నారు."
      },
      {
        "title": ""
      },
      {
        "title": "భాద్రపద శుద్ధ చవితినాడు యథావిధిగా వినాయకుని పూజించి ఈ శమంత కోపాఖ్యానాన్ని విని అక్షతలు తలపై వేసుకున్న వారికి, ఆరోజు చంద్ర దర్శనం అయినా కూడా అపనిందలు కలగవు అని శ్రీకృష్ణుడు చెప్పాడు. ఆ నాటి నుంచి ప్రతి సంవత్సరం భాద్రపద శుద్ధ చవితి రోజు దేవతలు, మహర్షులు, మానవులు తమ శక్తికి తగినట్లుగా గణపతిని పూజించి తమ కోరికలు తీర్చుకుంటున్నారు.ఈ కథను చదివి గాని, విని గాని తలపై అక్షతలను వేసుకొని వినాయక వ్రతాన్ని ముగించాలి. చివరగా వినాయకుని ఎదుట వీలైనన్ని గుంజీలు తీసి, సాష్టాంగ నమస్కారాలు చేయాలి."
      },
      {
        "title": ""
      },
      {
        "title": <span classname="highlight">సర్వేజనా సుఖినోభవంతు</span>
      },
    ],
    "title": "వినాయక కథ"
  },
  "mahasivaratri": {
    "CatID": [
      {
        "title": "భారతీయ తెలుగు సాంప్రదాయ పండగలన్నీ తిధులతోను,నక్షత్రాములతోను ముడిపడి ఉంటాయి.కొన్ని పండగలకు తిధులు,మరికొన్ని పండగలకు నక్షత్రాలు ప్రధానమవుతాయి. ఈ పద్ధతిలో ప్రతి నెల చాంద్రమాసము ప్రకారం కృష్ణ పక్షములోని ప్రదోష వ్యాప్తిగల చతుర్ధశి తిధిని మాసశివరాత్రి అంటారు.ఇది శైవులకు ఉపవాస వ్రతములకు ముఖ్యమైనదిగా భావించి శివున్ని కొలుస్తారు."
      },
      {
        "title": ""
      },
      {
        "title": "మాఘమాసములో కృష్ణ పక్ష చతుర్ధశి అర్ధరాత్రి వ్యాప్తి చెంది ఉన్నరోజును మహాశివరాత్రిగా పరిగణింపబడినదని శాస్త్ర వచనం. అమావాస్యకు ముందు వచ్చే కృష్ణ పక్ష చతుర్ధశినాడే శివరాత్రి జరుపుకోవాలని శాస్త్ర నిర్ణయము."
      },
      {
        "title": ""
      },
      {
        "title": "సంక్రాంతి పండగ తర్వాత వచ్చే పండగలలో ముఖ్యమైనది మహాశివరాత్రి.అన్ని పండగలు పగటి పూట జరుపుకుంటే ఈ పండగ మాత్రం రాత్రిపూట జరుపుకుంటాము.మహాశివరాత్రి రోజున అర్ధరాత్రి 12 గంటలకు జ్యోతి స్వరూపుడైన శివుడు లింగ రూపంలో దర్శనమిచ్చే పవిత్ర పర్వదినము. శివరాత్రి రోజు పగలంతా ఉపవాసం ఉండి రాత్రి సమయంలో శివుడి అనుగ్రహం కొరకు నిదర పోకుండా జాగరణతో మేలుకొని భక్తిశ్రద్ధలతో అభిషేకాలు,పూజలు,భజనలు చేస్తారు."
      },
      {
        "title": ""
      },
      {
        "title": "ఇది హిందువులకు అత్యంత పుణ్య ప్రదమైన రోజు.మహశివరాత్రిని హిందువులు ఏంతో గొప్ప పర్వదినంగా జరుపుకొని శివున్ని కొలిచి తరిస్తారు. మహాశివరాత్రి రోజు ముఖ్యంగా పాటించవలసిన నియమాలు."
      },
      {
        "title": ""
      },
      {
        "title": "1) ఉపవాసం ఉండటం 2) రాత్రి జాగరణ చేయడం 3) శివనామ స్మరణతో అభిషేకాలు చేయడం."
      },
      {
        "title": ""
      },
      {
        "title": <span classname="highlight">శివుడు లింగోద్భవ మూర్తిగా అవతరించడానికి గల కారణము:</span>
      },
      {
        "title": ""
      },
      {
        "title": "శివుడు లింగోద్భవ మూర్తిగా అవతరించడానికి ఒక పురాణ కధ ఉంది.ఒకానోక రోజు బ్రహ్మ,విష్ణువుల మధ్య మాట మాట పెరిగి వారీరువురిలో ఎవరు గొప్ప అని తేల్చుకోవలనుకున్నారు.ఈ విషయంలో వాదన తారాస్థాయికి చేరింది."
      },
      {
        "title": ""
      },
      {
        "title": "ఇద్దరిలో ఎవరూ తగ్గలేదు. ఇదంతా చూస్తున్న శివుడు వారికి తన శక్తిని చూపించాలని మాఘ మాస చతుర్ధశి తిధి రోజు ఇద్దరికీ మధ్య జ్యోతిర్లింగ రూపం దాల్చాడు. బ్రహ్మ,విష్ణువులు లింగాకారంలో ఉన్న ఆశివుని యొక్క ఆది,అంతం తెలుసుకోవలని విష్ణువు వరాహ రూపం ధరించి లింగాకారంలో ఉన్న శివలింగ అడుగు భాగాన్ని వెతుకుతూ వెళ్ళాడు.మరోవైపు బ్రహ్మ తన హంస వాహనమెక్కి ఆకాశమంతా తిరగడం ప్రారంభించాడు."
      },
      {
        "title": ""
      },
      {
        "title": "వీరిద్దరూ ఎంత ప్రయత్నించినా ఆ లింగం యొక్క మొదలు,చివర ఎదో అని తెలియక వెతుకుతూ అలసిపోయారు.చివరికి ఇక లాభం లేదనుకుని ఇద్దరు కలసి శివుని వద్దకు చేరుకొని మేము నీ శక్తిని తేల్చుకోలేకపోతున్నాము అని అడగగానే శివుడు చిరునవ్వు నవ్వి మీలో ఎవరు గొప్ప అనే పోటీతో వాదోప వాదనతో ఉన్నదానిని గమనించి మీ పోటీని తగ్గించడానికి నేను ఈ లింగాకారంగా అవతరించాల్సి వచ్చింది అని వారికి నిజరూపంతో వివరించి చెబుతాడు.అపుడు బ్రహ్మ విష్ణువులు శివుడి ఆధిక్యతను గ్రహించి పూజించి కీర్తిస్తారు.ఆ రోజే మహాశివరాత్రి అయినదని పురాణ కధనం."
      },
      {
        "title": ""
      },
      {
        "title": <span classname="highlight">శివరాత్రి నాడు చేయవలసిన శాస్త్రవిధులు :-</span>
      },
      {
        "title": ""
      },
      {
        "title": "మహా శివరాత్రి రోజు భ్రాహ్మీ మూహూర్తంలో నిద్రలేచి ఇల్లాంత శుభ్రపరచుకుని శుచిగా తలస్నానం చేసి పూజా గదిని శుభ్రం చేసుకోవాలి.గుమ్మాలకు తోరణాలు కట్టుకోవాలి.పూజగదిలో ముగ్గులు వేసుకుని రకరకాల పూలతో అలంకరించుకోవాలి. లింగకారంలో ఉన్న శివునికి శుద్ధ జలంతో,ఆవుపాలతో,పంచామృతంతో వివిధ పూజా ద్రవ్యాలతో,పుష్పాలతో అభిషేకించుకుని ముఖ్యంగా మారేడు దళాలను,బిల్వపత్రాలను,తుమ్మిపూలను,గోగుపూలు,తెల్లని,పచ్చని పూలతో శివనామాలను కాని పంచాక్షరీ మంత్రమైన ఓం నమశ్శివాయ అని స్మరిస్తూ పూజించాలి."
      },
      {
        "title": ""
      },
      {
        "title": "తాంబూలం, అరటి పండు,జామపండు,ఖర్జూరపండును సమర్పించి పూజ చేస్తున్న సమయంలో నిష్టతో శివ అష్టోత్తరం/పంచాక్షరీ మంత్రాన్ని పఠించాలి.ప్రాత:కాలం నుండి ఉదయం 9 గంటల లోపు అభిషేకాలు చేసే పూజకు ఉత్తమ ఫలితాలు ఉంటాయి. మననం చేసేవారిని కాపాడేది మంత్రం అంటారు కాబట్టి పరమేశ్వరుణ్ణి మనస్సులో నిరంతరం మననం చేసుకోవడం వలన అష్టైశ్వర్యాలు,సుఖ సంతోషాలు, భోగభాగ్యాలు కలుగుతాయి.శివరాత్రి రోజు అర్ధరాత్రి 12 గంటలకు లింగోద్భవ సమయం. ఈ సమయంలో కనుక శివున్నిఅభిషేకిస్తే పునర్జన్మ ఉండదని ప్రతీతి. శివుడు అభిషేక ప్రియుడు.స్వామికి భక్తితో నీళ్ళతో అభిషేకం చేసిన చాలు తమ భక్తుల భక్తికి స్వామి పొంగిపోతాడు అందుకే శివున్ని బోళాశంకరుడని పేరు."
      },
      {
        "title": ""
      },
      {
        "title": "సాయంత్రం 6 గంటల నుండి మరుసటి రోజు ఉదయం 6 గంటల వరకు భక్తి శ్రద్ధలతో శివ నామాలను,శివపురాణం మొదలగునవి చదువుకుంటే విశేష శుభఫలితాలు పొందుతారు. మహాశివుడు అనేవాడు మాతృవాత్సల్యం కలవాడు అంటే తల్లి తన బిడ్డను ఏ విధంగా రక్షించు కుంటుందో శివుడు తన భక్తుల భక్తికి పరవశించి కోరిన కోర్కెలను తీరుస్తూ రక్షించుకుంటాడు.ఈ మహా శివరాత్రికి పగలంతా ఉపవాసం ఉండి రాత్రంత జాగరణ చేసి మరుసటి రోజు స్నానం చేసి మహానైవేద్యంగా అన్నం కూరలు వండి దేవునికి నివేదన చూపించి ఉపవాస దీక్ష విరమణగావించాలి. ఈ పద్దతులలో చేస్తే ఎంతో పుణ్యప్రదంతో పాటు సమస్త గ్రహదోష నివారణ కలిగి దైవానుగ్రహం పొందుతారు."
      },
      {
        "title": ""
      },
      {
        "title": <span classname="highlight">శివుని గొప్పతనాన్ని తెలిపిన ఋగ్వేదం :</span>
      },
      {
        "title": ""
      },
      {
        "title": "వేదాలు, ఇతిహాసాలు, పురాణాలలో ముఖ్యమైనవి. వీటిలో ఋగ్వేదం చాలా గొప్పది. ఇందులోని రుద్రం ఇంకా గొప్పది. పంచాక్షరీలోని శివ అనే రెండక్షరాలు మరీ గొప్పవి. శివ అంటే మంగళకరమని అర్థం. శివస్వరూపం అత్యంత మంగళకరమైనది. ఆ పరమ శివుని అనుగ్రహం కోసం జరుపుకునే ముఖ్యమైన పండుగ మహా శివరాత్రి. పురాణాలలో తెలియజేసిన మహా శివరాత్రిని ఏటా మాఘమాసం కృష్ణపక్ష చతుర్థశినాడు జరుపుకుంటాం."
      },
      {
        "title": ""
      },
      {
        "title": "మహాశివరాత్రి శ్రీ శైలంలో ఏ రోజు నిర్వహిస్తారో ఆరోజే ప్రజలందరు మహాశివరాత్రి ఉత్సవాలు జరుపుకోవడం అనేది తరతరాలుగ వస్తున్న సాంప్రదాయం కాబట్టి ఇది గమనించి వ్యవహరించుకోవడం ఉత్తమం."
      }
    ],
    "title": "మహాశివరాత్రి"
  },
  "christmas":{
    "CatID": [

      {
        "title": "లోకరక్షకుడు క్రీస్తు జన్మదినమే క్రిస్మస్‌.జీసస్ జన్మించి నేటికి రెండు వేల ఏళ్లు దాటినా కరుణామయుడుగానూ, దయామయుడుగానూ క్రెస్తవులతో ఆరాధనలను అందుకుంటున్నాడు. ఏసుక్రీస్తు పుట్టిన రోజునే ప్రపంచ వ్యాప్తంగా క్రిస్మస్ పండుగను ఎంతో పవిత్రంగా జరుపుకుంటారు. జీసస్ జన్మించి నేటికి రెండు వేల ఏళ్లు దాటినా కరుణామయుడుగానూ, దయామయుడుగానూ క్రెస్తవులతో ఆరాధనలను అందుకుంటున్నాడు."
      },
      {
        "title": ""
      },
      {
        "title": "రెండు వేల ఏళ్ల కిందట రోమ్ సామ్రాజ్యాన్ని పాలించే ఆగస్టస్ సీజర్ తన రాజ్యంలో ఎంత మంది జనాభా ఉన్నారో లెక్కించాడు. సులభంగా ఈ లెక్కలు సేకరించడానికి వీలుగా ప్రజలందరూ ఎవరి స్వగ్రామాలకు వాళ్లు డిసెంబరు 25 తేదీలోగా చేరుకోవాలని ఆజ్ఞాపించాడు. అదే సమయంలో రోమన్ సామ్రాజ్యంలోని నజరేతు పట్టణంలో ఉండే మేరీతో జోసెఫ్‌కు పెళ్లి కుదిరింది. ఒక రోజున మేరీకి గాబ్రియేల్ అనే దేవదూత కలలో కనబడి ‘ఓ మేరీ! నీవు దైవానుగ్రహం పొందావు. కన్యగానే గర్భం దాల్చి ఓ కుమారునికి జన్మనిస్తావు. అంతే కాదు పుట్టే బిడ్డకు ఏసు అని పేరు పెట్టాలని, అతడు దేవుని కుమారుడు అని తెలియజేసింది. ఏసు అంటే రక్షకుడు అని అర్థం."
      },
      {
        "title": ""
      },
      {
        "title": "దేవదూత చెప్పిన విధంగానే మేరీ గర్భం దాల్చింది. ఈ విషయం తెలిసిన జోసెఫ్ ఆమెను వివాహం చేసుకోరాదని నిర్ణయించుకున్నాడు. అయితే ఒక రోజు రాత్రి కలలో అతనికి దేవదూత కనపడి మేరీని నీవు విడిచిపెట్టవద్దు. ఆమె భగవంతుని వరంతో గర్భవతి అయింది. కాబట్టి ఆమెకు పుట్టే కొడుకు దేవుని కుమారుడు. తనను నమ్మిన ప్రజలందరిని వాళ్ల పాపాల నుంచి రక్షిస్తాడు అని పలికింది. జోసెఫ్ దైవాజ్ఞను అనుసరించి మేరీని ప్రేమతో ఆదరించాడు. ఇక రాజాజ్ఞ ప్రకారం జోసెఫ్, మేరీలు తమ స్వగ్రామమైన బెత్లేహామ్‌కు బయలుదేరారు. అయితే వారు అక్కడకు చేరుకునేసరికి ఉండటానికి వసతి దొరకలేదు. చివరకు ఒక సత్రం యజమాని తన పశువుల పాకలో వారికి ఆశ్రయం కల్పించాడు. అక్కడే ఏసుకు మేరీ జన్మనిచ్చింది. ఆ రాత్రి ఆ ఊరికి పక్క పొలాల్లో కొంతమంది తమ గొర్రెల మందలకు కాపలా కాస్తున్నారు. ఆ సమయంలో ఆకాశం నుంచి ఒక దేవదూత వారి ముందుకు దిగి వచ్చాడు. ఆ దూత చుట్టూ వెలుగులు ప్రసరించడంతో గొర్రెల కాపర్లు భయపడ్డారు. మీరు భయపడకండి, ఒక సంతోషకరమైన శుభవార్తను తెలియజేయడానికి ఇక్కడకు వచ్చాను. ఈ రోజు బెత్లెహోమ్‌లోని ఓ పశువుల పాకలో లోక రక్షకుడు పుట్టాడు, ఆయనే మీ అందరికీ ప్రభువు. ఒక పసికందు గుడ్డల్లో చుట్టి, పశువుల తొట్టిలో అమ్మ పొత్తిల్లలో పడుకుని ఉంటాడని, ఇవే మీకు ఆనవాళ్లని, అతడే లోకరక్షకుడు అని చెప్పాడు. గొర్రెల కాపర్లతో ఈ విషయం గురించి చెబుతుండగానే ఆ ప్రాంతమంతా ఆకాశం నుంచి దిగివచ్చిన దేవదూతలతో నిండిపోయింది."
      },
      {
        "title": ""
      },
      {
        "title": "అలా అక్కడకు వచ్చిన దేవదూతలు దేవున్ని స్తుతిస్తూ గీతాలు పాడి మాయమయ్యారు. గొర్రెల కాపరులు హుటాహుటిన దేవదూత చెప్పిన పశువుల పాకను చేరుకున్నారు. అక్కడ పశువుల తొట్టిలో పడుకొని ఉన్న శిశువుతోపాటు మేరీ, జోసెఫ్‌లను చూశారు. దేవదూత తమకు చెప్పిన విషయాన్ని వారు అందరికి తెలియజేశారు. అలా రెండు వేల సంవత్సరాల కిందట డిసెంబరు 24 న అర్థరాత్రి 12 తర్వాత జీసస్ జన్మించాడు. అంటే డిసెంబరు 25న జన్మించడంతో ఆ రోజునే క్రిస్మస్ జరుపుకుంటారు. క్రిస్మస్‌కు చాలా రోజుల ముందే పండుగ సందడి మొదలవుతుంది. దీనికోసం క్రైస్తవులు తమ ఇళ్లను, చర్చ్‌లను అందంగా అలంకరిస్తారు. వెదురు బద్దలు, రంగుల కాగితాలతో ఒక పెద్ద నక్షత్రాన్ని తయారుచేసి ఇంటిపై వేలాడ దీస్తారు. అలాగే తమ ఇంట్లో క్రిస్‌మస్‌ ట్రీ ఏర్పాటు చేస్తారు. దీన్ని రంగు రంగుల కాగితాలు, నక్షత్రాలు, చిరుగంటలు, చిన్న చిన్న గాజు గోళాలతోను అలంకరిస్తారు. ఇది ఈ పండుగ ప్రత్యేకత."
      },
      {
        "title": ""
      },
      {
        "title": "క్రిస్మస్ ముందు రోజు రాత్రి శాంతా క్లాజ్ పిల్లలకు బహుమతులు ఇచ్చి వెళ్తాడని నమ్ముతారు. అందుకోసం పిల్లలు తమ మేజోళ్లను వేలాడదీసి ఉంచుతారు. ఇలా ఉంచితే శాంతా క్లాజ్ వాటిలో బహుమతులను వేసి వెళ్తాడని నమ్మకం. క్రిస్‌మస్ రోజున బంధు మిత్రుల ఇళ్ళకు వెళ్లి శుభాకాంక్షలు తెలుపుతారు. క్రిస్‌మస్‌ ఏడాదికి ఒకసారి మాత్రమే వస్తుంది, కాబట్టి వచ్చేటప్పుడు ప్రేమాభిమానాలను సుఖసంతోషాలను తెస్తుందని నమ్ముతారు."
      }
    ],
    "title": "క్రిస్మస్"
  },
  "sankranthi": {
    "CatID": [
      {
        "title": "తెలుగు ప్రజలు జరుపుకొనే అతిపెద్ద పండుగ సంక్రాంతి. ఈ పండుగను నాలుగు రోజులపాటు ఘనంగా జరుపుకొంటారు. సూర్యుడు మకర రాశిలోకి ప్రవేశించిన రోజునే మకర సంక్రాంతి పండుగ జరుపుకుంటారు. గొబ్బెమ్మలు, భోగి మంటలు, గంగిరెద్దులు, పిండి వంటలు, హరిదాసు కీర్తనలు, రథం ముగ్గులు, కోడి పందాలు ఇలా సంకాంత్రి వచ్చిందంటే ఆ సందడే వేరు."
      },
      {
        "title": ""
      },
      {
        "title": "ఈ పండుగను నాలుగు రోజులు జరుపుకుంటారు. ఈ పండుగ తొలి రోజును 'భోగి'గాను, రెండో రోజును 'మకర సంక్రాంతి'గాను, మూడో రోజును 'కనుమ'గాను పిలుస్తారు. నాలుగో రోజును 'ముక్కనుమ' గాను పిలుస్తారు."
      },
      {
        "title": ""
      },
      {
        "title": <span classname="highlight">మొదటి రోజు ( భోగి ) :</span>
      },
      {
        "title": ""
      },
      {
        "title": "సంక్రాంతికి ఒక రోజు ముందు భోగి పండుగతో సంబరాలు మొదలవుతాయి. భోగి అంటే భోగ భాగ్యాలను అనుభవించే రోజు అని అర్ధం. పాడి పంటలు సమృద్ధిగా ఇండ్లకు వచ్చే సమయం. ఈ రోజు సూర్యోదయానికి పూర్వమే నిద్రలేచి అభ్యంగన స్నానానంతరం ప్రతి ఇంటి ముందు భోగి మంటలు వేసుకొని పాతకు స్వస్తి చెప్పి నూతనత్వానికి స్వాగతం పలుకుతూ భోగి మంటలలో పాత పనికిరాని బట్టలను, వస్తువులను వేసి పీడలను,అరిష్టాలను తొలగించుకుంటారు. తెల్లవారక ముందే భోగి మంటలతో మొదలుకుని కుటుంబంలో ఆనంద కోలాహలం ప్రారంభం అవుతుంది. మనలో ఉన్న బద్దకాన్ని, అశ్రద్ధను, మనసులో ఉన్న చెడు తలంపులను ఈ భోగి మంటలలో వేసి ఈ రోజు నుండి నూతన ఆనంద, ఆప్యాయతలతో కూడుకొని ఉన్న జీవితాన్ని ప్రారంభిస్తున్నామని ఆత్మారామునికి మాట ఇచ్చి భవగత్ సన్నిదిలో నిశ్చయ సంకల్పం చేసుకోవడం జరుగుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": "భోగి రోజున బొమ్మల కొలువు, పేరంటము కూడా చేస్తారు. ముఖ్యంగా భోగి పండుగ రోజు పెద్దలు తమ ఇంట్లోని చిన్నారుల తలపై రేగిపళ్లు పోస్తారు. భోగిపండ్ల కోసం రేగుపండ్లు, చెరుకుగడలు, బంతిపూల రేకులు, చిల్లర నాణేలు వాడతారు. కొందరు శనగలు కూడా కలుపుతారు. భోగిపండ్లను పిల్లల తల మీద పోయడం వలన శ్రీమన్నారాయణుడి దివ్య ఆశీస్సులు లభిస్తాయని భావిస్తారు. భోగి పండ్లు పోయడం వలన పిల్లల మీద ఉన్న చెడు దృష్టి తొలగిపోతుంది. తలపై భాగంలో బ్రహ్మరంధ్రం ఉంటుంది. భోగి పండ్లను పోసి దాని ప్రేరేపితం చేస్తే, పిల్లల్లో జ్ఞానం పెరుగుతుంది."
      },
      {
        "title": ""
      },
      {
        "title": "రేగి పండ్లను బదరీఫలం అని కూడా పిలుస్తారు. పురాణ కధనము ప్రకారం శివుణ్ని ప్రసన్నము చేసుకోవడానికి నరనారాయణులు బదరికావనంలో ఘోర తపస్సు చేశారట. ఆ సమయంలో దేవతలు వారి తలల మీద బదరీ ఫలాలని కురిపించారని చెబుతారు. ఆనాటి సంఘటనకు ప్రతీకగా పిల్లలను నారాయణుడిగా భావించి భోగిపండ్లను పోసే సంప్రదాయం వచ్చిందని ప్రతీతి."
      },
      {
        "title": ""
      },
      {
        "title": "భోగి ముగిశాక సూర్యుడు దక్షిణాయణం నుంచి ఉత్తరాయణానికి మరలుతాడు. ఆ రోజే మకర రాశిలోకి అడుగుపెడతాడు. సంక్రాంతి సూర్యుడి పండుగ కాబట్టి సూర్యుణ్ని పోలిన గుండ్రని రూపం, ఎర్రటి రంగు కారణంగా దీనికి అర్కఫలం అనే పేరు వచ్చింది. సూర్యభగవానుడి ఆశీస్సులు పిల్లవాడికి లభించాలనే సూచనగా ఈ భోగిపండ్లను పోస్తారు. కౌమర్యంలోకి అడుగు పెట్టడానికి ముందే అంటే 12 ఏళ్లలోపు చిన్నారుల తలపై భోగి పండ్లను పోయవచ్చు."
      },
      {
        "title": ""
      },
      {
        "title": <span classname="highlight">రెండవ రోజు ( మకర సంక్రాంతి ) :</span>
      },
      {
        "title": ""
      },
      {
        "title": "సంక్రాంతి అంటే కొత్త వెలుగులు. ముఖ్యంగా సంక్రాంతి రోజున గాలిపటాల వేడుక నిర్వహించడం అనేది సాంప్రదాయము. ఈ పండుగను పూర్వం మన పెద్దలు దాదాపు 33 రోజలపాటు ఘనంగా జరుపుకునేవారు.కానీ మారుతున్న కాలానికి అనుగుణంగా ప్రస్తుతం ఈ పండుగను 4 రోజులపాటు మాత్రమే నిర్వహించుకుంటున్నారు. అయితే భగీరథుడు గంగను భూలోకానికి తీసుకువచ్చి సాగరులకు శాప విమోచనం చేయించింది ఈ రోజే అని శాస్త్రాలు చెబుతున్నాయి. ఇక సంక్రాంతికి నెల రోజుల ముందు నుండే పండుగ వాతావరణం కనిపిస్తుంది. మకర సంక్రమణం అంటే పాత పోయి కొత్తదనానికి స్వాగతం పలికే రోజు అని అర్థం. ఈ పర్వదినాలలో విష్ణు మూర్తిని ఆరాధిస్తాం."
      },
      {
        "title": ""
      },
      {
        "title": "సంక్రాంతి పండుగకు పంట కోతలు అయిపోయి ధాన్యం ఇంటికి వస్తుంది. దీంతో పొలాల్లో ఉండే కీటకాలు ఇంట్లోకి రాకుండా వాకిళ్ళలో కళ్లాపి చల్లి, ముగ్గులు వేసి అందులో రకరకాల రంగులను నింపి వాటి మధ్యలో ఆవు పేడతో చేసిన గొబ్బెమ్మలను పెడతారు. శ్రీమన్నారాయణుడి ప్రత్యక్షరూపం సూర్యభగవానుడు. సంక్రాంతి పర్వదినం రోజున ఉదయాన్నే లేచి తలస్నానం చేసి కొత్త దుస్తులను ధరించి, సూర్యభగవానుడిని ఆరాధించాలి. ఆ తర్వాత ఆదిత్యహృదయం, సూర్యాష్టకం పారాయణం చేయాలి. ఇక ఇంట్లో ఉండే పెద్దవాళ్ళ ఆశీర్వాదం తీసుకోవాలి."
      },
      {
        "title": ""
      },
      {
        "title": "ఈ పండుగ రోజున గడపకు పసుపు రాసి, కుంకుమ పెట్టి, వాకిట్లో ముగ్గులు వేసి వాటిలో ఆవు పేడ గొబ్బెమ్మలు పెట్టడం, ఇంట్లో పిండివంటలు, పరమాన్నం చేసి శ్రీమన్నారాయణుడిని ఆరాధించడం వలన అన్ని శుభాలు జరుగుతాయని శాస్త్రాలు చెబుతున్నాయి.ఈ రోజు గాలి పటాలను ఎగుర వేయటం, ఆడవారు ముగ్గులు వేయటం, ముగ్గుల పోటీలు జరుపుకోవటం చేస్తారు."
      },
      {
        "title": ""
      },
      {
        "title": "అయ్యప్ప దీక్ష చేసేవారు 40 రోజుల తరువాత అయ్యప్పను, మకర జ్యోతిని కూడా ఈ రోజే దర్శించుకుంటారు."
      },
      {
        "title": ""
      },
      {
        "title": <span classname="highlight">మూడవ రోజు ( కనుమ ) :</span>
      },
      {
        "title": ""
      },
      {
        "title": "ఈ కనుమ రోజున పశువులను లక్ష్మి స్వరూపాలుగా భావించి, అందంగా అలంకరించి పూజిస్తారు. ఇలా చేయటం వలన ఇంట్లో సంపదలు వృద్ధి చెందుతాయని నమ్మకం. ఎద్దుల పందాలు, కోడి పందాలు కూడా ఈ రోజున నిర్వహిస్తారు. సంక్రాంతిని సాగనంపడానికి ఈ రోజున రథం ముగ్గులు కూడా వేస్తారు. ఈ రోజుతో సంక్రాంతి ముగుస్తుంది."
      },
      {
        "title": ""
      },
      {
        "title": "కొన్ని ప్రాంతాలలోని ప్రజలు నాలుగో రోజు 'ముక్కనుమను' కూడా జరుపుకుంటారు."
      }
    ],
    "title": "సంక్రాంతి"
  },
  "holi":
  {
    "CatID": [
      {
        "title": "'హోలీ’ వస్తుందంటే చాలు.. దేశమంతా పండుగే. దీపావళి తర్వాత దేశంలో అత్యంత వేడుకగా జరుపుకునే పండుగల్లో ఇదీ ఒకటి. ఈ పండుగ సత్య యుగం నుంచి జరుపుకుంటున్నట్లు హిందూ పురాణాలు తెలుపుతున్నాయి. హోలీ అంటే అగ్ని లేదా అగ్నితో పునీతమైనది అని అర్థం. హోలీని ‘హోళికా పుర్ణిమ’గా కూడ వ్యవహరిస్తారు. ఏటా ఫాల్గుణ మాసంలో పౌర్ణమి రోజున వచ్చే ఈ పండుగను.. హోలీ, కాముని పున్నమి, డోలికోత్సవం అని కూడా అంటారు. ఈ పండుగ పుట్టుపుర్వోత్తరాల గురించి పురాణాల్లో భిన్నగాథలు ప్రచారంలో ఉన్నాయి. అవేంటో చూడండి.",
      },
      {
        "title": "",
      },
      {
        "title": "వంగ దేశంలో డోలోత్సవం లేదా డోలికోత్సవం జరుపుకుంటారు. ఆ రోజు శ్రీకృష్ణుడు గోపికలతో కలిసి బృందావనంలోని పువ్వులతో, రంగులతో ఈ ఉత్సవాన్ని జరుపుకున్నట్లుగా భావిస్తారు. ఇలా రంగులు, పూలు చల్లుకోవడం ద్వారా ప్రేమ, సౌభాగ్యాలు వెల్లివిరిస్తాయని నమ్ముతారు.",
      },
      {
        "title": "",
      },
      {
        "title": <span classname="highlight">డోలిక అంటే?:</span>,
      },
      {
        "title": "డోలిక అంటే ఉయ్యాల అని అర్థం. బాలబాలకృష్ణుడిని ఫాల్గుణ మాసం, పూర్ణిమ తిథిలో ఉయ్యాలలో వేసినట్లు పురాణాలు తెలుపుతున్నాయి. ఈ సందర్భంగా పశ్చిమ బెంగాల్‌లో హోలీ రోజున శ్రీకృష్ణుడి ప్రతిమను ఊయలలో వేసి ‘డోలికోత్సవం’ జరుపుతారు. ఈ హోలి రోజున శ్రీకృష్ణుడు.. రాధను ఊయాలలో పెట్టి రంగులు పులిమినట్లు కూడా చెబుతుంటారు.",
      },
      {
        "title": "",
      },
      {
        "title": "కృతయుగంలో రఘునాథుడనే సూర్యవంశపు మహారాజు వుండేవాడు. ఓ రోజు ప్రజలంతా వచ్చి ‘హోళిక’ అనే రాక్షసి తమ పిల్లలను బాధిస్తోందని మొరపెట్టుకుంటారు. ఆ సమయంలో అక్కడే ఉన్న నారద మహర్షి.. ఏటా ఫాల్గుణ పూర్ణిమ రోజు హోళికను పూజిస్తే బాధలు తొలగిపోతాయని తెలుపుతాడు. ఆ పూజలు పగటి వేళ చేస్తే కష్టాలు వస్తాయని, అంతా రాత్రివేళ నిర్వహించాలని వివరిస్తాడు. దీంతో అప్పటి నుంచి ‘హోలీ’ పూజలు నిర్వహిస్తున్నట్లు పూర్వికులు తెలుపుతుంటారు.",
      }
    ],
    "title": "హోలీ - రంగుల పండుగ",
  },
  "krishnastami":
  {
    "CatID": [
      {
        "title": "కృష్ణ జన్మాష్టమి హిందూ ఇతిహాసాలలో శ్రీ మహావిష్ణువు ఎనిమిదవ అవతారం శ్రీకృష్ణుడి జన్మదినము. కృష్ణ జన్మాష్టమిని కృష్ణాష్టమి అని లేదా జన్మాష్టమి లేదా గోకులాష్టమి లేదా అష్టమి రోహిణి అని కూడా పిలుస్తారు.",
      },
      {
        "title": "జన్మాష్టమి - శ్రీకృష్ణుని జననం - సంవత్సరంలో జరిగే అతి పెద్ద సంఘటనలలో ఒకటి. ఆధ్యాత్మికం నుండి ఈ భౌతిక ప్రపంచంలోకి 5,000 సంవత్సరాల క్రితం దేవుని ఆగమనాన్ని భక్తులు జరుపుకోవడంలో ఇది క్రిస్మస్కు సమానమైన వైష్ణవమైనది. కృష్ణ అనే పేరుకు ఆకర్షణీయుడు అని అర్థం. శ్రీకృష్ణుడు పూర్తిగా ఆరు సంపదలను ప్రదర్శిస్తాడు: అందం, జ్ఞానం, కీర్తి, సంపద, బలం మరియు వినయం. అందువలన, అతను దేవుని యొక్క సర్వోన్నతమైన ఆకర్షణీయమైన వ్యక్తగా ఆరాధించబడ్డాడు.",
      },
      {
        "title": "జన్మాష్టమిని ప్రపంచవ్యాప్తంగా అన్ని ఇస్కాన్ కేంద్రాలలో అసమానమైన వైభవంగా జరుపుకుంటారు. రోజంతా సంగీతం, నాటకం, నృత్యం మరియు భగవంతుని మంత్రముగ్ధమైన కాలక్షేపాలను కీర్తిస్తూ కీర్తనల ప్రదర్శనలు, శ్రీకృష్ణుడు కనిపించిన అర్ధరాత్రి గంటకు దారితీస్తాయి. కీర్తన మరియు నృత్యంతో కూడిన అర్ధరాత్రి సేవ తర్వాత అందరికీ బహుళ-కోర్సు శాఖాహార విందు ఉంటుంది.",
      },
      {
        "title": "",
      },
      {
        "title": <span classname="highlight">తిథి :</span>,
      },
      {
        "title": "శ్రీకృష్ణుడు దేవకి వసుదేవులకు, దేవకి ఎనిమిదో గర్భంగా, శ్రావణమాసము కృష్ణ పక్షం అష్టమి తిథి రోజు, కంసుడి చెరసాలలో, జన్మించాడు. చాంద్రమాన పంచాగం ప్రకారం శ్రావణ బహుళ అష్టమి తిథి. ఇదే రోజు రోహిణి నక్షత్రము కొద్ది సేపు చంద్రాయుక్తమై ఉంటుంది",
      },
      {
        "title": "",
      },
      {
        "title": <span classname="highlight">కృష్ణాష్టమి పండుగ విధానం</span>,
      },
      {
        "title": "చేతవెన్న ముద్ద చెంగల్వపూదండ",
      },
      {
        "title": "బంగారు మొలతాడు పట్టుదట్టి",
      },
      {
        "title": "సందె తావీదులు సరిమువ్వ గజ్జెలు",
      },
      {
        "title": "చిన్ని కృష్ణ నిన్ను చేరికొలుతు",
      },
      {
        "title": "",
      },
      {
        "title": "కృష్ణాష్టమి నాడు భక్తులు పగలంతా ఉపవాసం ఉండి, సాయంత్రం శ్రీకృష్ణుని పూజిస్తారు. శ్రావణ మాసంలో లభించే పళ్ళు, అటుకులు, బెల్లం కలిపిన వెన్న, పెరుగు, మీగడ స్వామికి నైవేద్యంగా పెడతారు. ఊయల కట్టి అందులో శ్రీకృష్ణ విగ్రహమును పడుకోబెట్టి ఊపుతూ రకరకాల పాటలు, కీర్తనలు పాడతారు.",
      },
      {
        "title": "",
      },
      {
        "title": "పుర వీధుల్లో ఎత్తుగా ఉట్లు కట్టి పోటీపడి వాటిని కొడతారు. అందుకే ఈ పండుగని 'ఉట్ల పండుగ' లేదా 'ఉట్ల తిరునాళ్ళు' అని పిలుస్తారు.",
      },
      {
        "title": "",
      },
      {
        "title": "భక్తిశ్రద్ధలతో శ్రీకృష్ణ జయంతి వ్రతంగా ఆచరిస్తే గోదానం చేసిన ఫలితం, కురుక్షేత్రంలో సువర్ణదానం చేసిన ఫలం దక్కుతుందని బ్రహ్మాండ పురాణం చెప్పింది. కలియుగంలో కల్మషాల్ని హరించి, పుణ్యాల్ని ప్రసాదించే పర్వదినం ఇదని కూడా వివరించింది.. దుష్టశిక్షణ.. శిష్ట రక్షణ... అన్న గీతోపదేశంతో మానవాళికి దిశనిర్దేశం చేశారు కృష్ణభగవానుడు. మహాభారత యుద్ధాన్ని ముందుండి నడిపించిన మార్గదర్శి ఆయన. మహా భాగవతం కథలను విన్నా... దృశ్యాలను తిలకించినా జీవితానికి సరిపడా విలువలెన్నో బోధపడతాయి.",
      },
      {
        "title": "ఆ కావ్యం ఇప్పటి పరిస్థితులకు ఒక మార్గదర్శకంగా ఉండటం కృష్ణుడి మహోన్నత వ్యక్తిత్వానికి, ఆయన లీలలకు అద్దం పడుతోంది. ద్వాపరయుగంలో జన్మించిన కృష్ణుడు నేటి కలియుగానికి ఆదర్శంగా నిలుస్తున్నారు. అందుకే ఆయన్ను అందరూ తమ ఇష్టదైవంగా కొలుస్తున్నారు. వివిధ రూపాల్లో, సంప్రదాయాలతో భక్తిప్రపత్తులతో కృష్ణుడిని కొలుస్తున్న ఆయా రాష్ట్రాల వారి సంస్కృతి, సంప్రదాయాలు మన భారతీయ సంస్కృతికి విలక్షణమైన అందాన్ని తెస్తాయి.",
      }
    ],
    "title": "కృష్ణాష్టమి",
  },
  "deepavali":
  {
    "CatID": [
      {
        "title": "దీపావళి, లేదా లైట్ల పండుగ, హిందూ నూతన సంవత్సరాన్ని సూచిస్తుంది మరియు భూమిపై ఉన్న అనేక సుప్రీం లార్డ్ యొక్క కాలక్షేపాలతో సంబంధం కలిగి ఉంటుంది. దీపావళి అత్యంత ప్రసిద్ధ వేద సెలవుదినం మరియు ఈ రోజు ఇస్కాన్ దేవాలయాలు మరియు అమెరికా వైట్ హౌస్ వంటి విభిన్న ప్రదేశాలలో ఈవెంట్‌ల ద్వారా గుర్తించబడుతుంది.",
      },
      {
        "title": "",
      },
      {
        "title": "ఈ రోజు చాలా ముఖ్యమైనది, ఎందుకంటే ఇది దుర్మార్గుడైన రావణుడిని ఓడించిన తరువాత, కృష్ణుడి అవతారమైన శ్రీరాముడు తన అయోధ్య రాజ్యానికి తిరిగి రావడాన్ని సూచిస్తుంది. రాముడు ఆనందంగా తిరిగి వచ్చినందుకు ఆకాశాన్ని వెలిగించే దీపాలు లేదా దీపాలను వెలిగించిన పౌరులందరూ రాముడికి స్వాగతం పలికారు. ఇది శ్రీకృష్ణుడు రాక్షసుడైన నరకాసురుడిని పంపిన రోజును కూడా సూచిస్తుంది.",
      },
      {
        "title": "",
      },
      {
        "title": "ఈ విధంగా దీపావళి చీకటిపై కాంతి మరియు చెడుపై మంచి విజయాన్ని సూచిస్తుంది. ఈ పండుగ ఆధ్యాత్మిక జ్ఞానోదయం కోసం మన స్వంత హృదయాలలో దీపాన్ని వెలిగించడం ద్వారా మరియు మన జీవితాల్లోకి భగవంతుడిని స్వాగతించడం ద్వారా ఆధ్యాత్మిక పునరుద్ధరణ సమయాన్ని సూచిస్తుంది. ఈ పండుగ తరచుగా విస్తృతమైన బాణసంచా ప్రదర్శనలు, దీపావళి దీపాలను వెలిగించడం మరియు విందులతో జరుపుకుంటారు.",
      },
      {
        "title": "",
      },
      {
        "title": "నరక చతుర్దశి ఆచరణ వెనక ఉన్న గాథల్లో నరకాసురుడి గాథ ప్రధానమైంది.   హిరణ్యాక్షుడు లోకానికి ఉపద్రవంగా భూదేవిని చుట్టచుట్టి సముద్రంలో ముంచినప్పుడు విష్ణుమూర్తి వరాహావతారమెత్తి, ఆ రాక్షసుని సంహరించి భూదేవిని ఉద్ధరించాడు. ఆ సందర్భంగా భూదేవికి విష్ణుమూర్తి వరప్రసాదం వలన భీముడనే పుత్రుడు జన్మించాడు. అతనే దుర్మార్గుడైన నరకాసురునిగా పేరొందాడు. నరకుడు ప్రాగ్జోతిషపురం రాజధానిగా కాపరూప రాజ్యాన్ని పాలిస్తూ ఉండేవాడు. భూమాత తన కుమారుని రాక్షసత్వానికి దూరంగానే పెంచింది. దురదృష్టవశాత్తు నరకుడు అసుర ప్రభావంలోపడి ఘోరతపస్సు చేసి అనేక వరాలు పొందాడు. తనకు తన తల్లి చేతిలో తప్ప మరణం సంభవించకూడదని కూడా వరం పొందాడు. స్వయాన తన తల్లే తనను చంపదని అతని ధీమా. ఆ వరగర్వంతో అతను కావించిన దుష్కార్యాలు పరాకాష్టకు చేరి దేవతలను తీవ్ర అశాంతికి గురి చేసాయి. విష్ణుద్వేషియై దేవతలను హింసించసాగాడు. దేవమాత అదితి కర్ణ్భారణాలను, వరుణ ఛత్రాన్ని అపహరిస్తే శ్రీకృష్ణుడు ఇతనిని ద్వందయుద్ధంలో ఓడించి, వాటిని తిరిగి అదితికి అందజేసాడు.",
      },
      {
        "title": "",
      },
      {
        "title": "మరొకప్పుడు మదపుటేనుగు రూపంలో విశ్వకర్మ పుత్రికను చెరపట్టాడు. వీరూవారను విచక్షణ లేకుండా గంధర్వ, దేవ, మానవ కన్యలను బలవంతంగా అపహరించి, తన అంతఃపుర పంజరంలో బంధించడం ఇదనికొక వ్యసనం. ఇతని దౌర్జన్యాలు అంతటితో ఆగక చివరకు ఇంద్రునిపైకి కూడా దండెత్తి ఆయన అధికార ముద్రను అపహరించడంతో ఈ అసుర ప్రముఖుని దురంతం పరాకాష్టనందుకుంది.ఇంద్రుడు ఆపదరక్షకుడైన శ్రీకృష్ణుని శరణువేడగా గోపాలుడు నరుకునిపై దండెత్తాడు. అయితే నరకాసురుని విషపు బాణానికి శ్రీకృష్ణుడు ఒక క్షణంపాటు నిశ్చేష్టుడయ్యాడు. అది గమనించి ఆయనతో కూడానే ఉన్న ఆయన సతీమణి సత్యభామ ఉగ్రురాలై భయంకరమైన తన బాణాన్ని ప్రయోగించి సంహరించింది. ఆశ్వయుజ బహుళ చతుర్దశినాడు లోక కంటకుడైన నరకుని మరణం సంభవించింది. యాదృచ్ఛికంగా నరకాసుని మరణం సత్యభామ రూపంలో తన తల్లి భూదేవి చేతిలోనే సంభవించింది.",
      },
      {
        "title": "",
      },
      {
        "title": "తన పుత్రుని పేరైనా కలకాలం నిలిచి ఉండేలా చేయమని సత్యభామ ప్రార్థించడంతో ఆ రోజు నరక చతుర్థశిగా పిలువబడుతుందని వరం ప్రసాదిస్తాడు శ్రీకృష్ణుడు. నరకుని చెరనుండి సాధుజనులు, పదహారువేలమంది రాజకన్యలు విడిపించబడ్డారు, ధ్రర్మం సుప్రతిష్టమైంది. నరకాసురుని పీడ విరగడైందన్న సంతోషంతో ఆ మరుసటి రోజు ప్రజలు సంబరాలు జరుపుకుంటారు. ఈ సంబరాలు జరుపుకునే రోజు అమవాస్య కావడంతో, చీకటిని పారద్రోలుతూ ప్రజల దీపాలతో తోరణాలు వెలిగించి, బాణాసంచా కాల్చి వేడుక చేసుకున్నారు. కాలక్రమంలో అదే దీపావళి పర్వదినంగా మారింది.",
      },
    ],
    "title": "దీపావళి",
  },
  "rathayatra":
  {
    "CatID": [
      {
        "title": "పూరీ క్షేత్రాన్ని పురుషోత్తమ క్షేత్రమని, శ్రీక్షేత్రమని, శంఖక్షేత్రమని, నీలాచలమని, నీలాద్రి అని, జగన్నాథపురి అనే పేర్లతో పిలుస్తారు. ఇక్కడ శ్రీమహావిష్ణువు జగన్నాథుడిగా పూజలందుకుంటున్నాడు.",
      },
      {
        "title": "",
      },
      {
        "title": "భగవంతుడు భక్తుల మధ్యకు వచ్చి అత్యంత వైభవంగా జరుపుకొనే మహోత్సవం పూరీ జగన్నాథుని రథయాత్ర. ఏడాదంతా గర్భాలయంలో ఏండే జగన్నాథుడు ఆషాడ శుద్ధ విదియ నాడు మాత్రం తన సోదరి, సోదరులు సుభద్ర, బలభద్రులతో కలసి రథాలను అధిరోహించి సాగే ఈ యాత్రను తిలకించేందుకు దేశ విదేశాల నుంచి లక్షలాదిగా భక్తులు తరలివస్తారు. ఆషాఢ శుక్ల విదియ రోజున నిర్వహించే రథయాత్ర వేడుకకు అక్షయ తృతీయ నుంచే సన్నాహాలు మొదలవుతాయి. వేసవి తీవ్రత మొదలవడంతో విగ్రహాలకు చందన లేపనాన్ని పూస్తారు. దీనినే ‘గంధలేపన యాత్ర’ అని కూడా అంటారు. అక్షయ తృతీయ రోజున పూరీ క్షేత్రంలో రథాల తయారీ మొదలవుతుంది. పూరీ రాజు నివాసం ఎదుట ఆలయ ప్రధాన కార్యాలయానికి చేరువలో రథాల తయారీ కొనసాగుతుంది. అక్షయ తృతీయ నాటి నుంచి జగన్నాథుని చందనయాత్ర కూడా మొదలవుతుంది.",
      },
      {
        "title": "",
      },
      {
        "title": "కుంభమేళా మినహా, భారతదేశంలోని పూరీలో సాంప్రదాయకంగా నిర్వహించబడే రథయాత్ర భారతదేశంలోని అత్యధిక మంది యాత్రికులను ఆకర్షిస్తుంది. ఈ పండుగ సందర్భంగా, అందంగా అలంకరించబడిన జగన్నాథ దేవతలు (విశ్వానికి ప్రభువు), బలదేవ్ (కృష్ణుని సోదరుడు) మరియు సుభద్ర (కృష్ణుని సోదరి) కవాతు కోసం ప్రత్యేకంగా నిర్మించిన మూడు పెద్ద రథాలపై తీసుకువెళతారు.",
      },
      {
        "title": "",
      },
      {
        "title": "గ్రంథాల ప్రకారం, కృష్ణుడు ద్వారకకు గొప్ప రాజు అయినప్పటికీ, అతని బాల్యం బృందావన గ్రామంలో సాధారణ గోవుల అబ్బాయిలు మరియు బాలికల మధ్య గడిచింది. బృందావనంలోని ఆటలాడే కాలక్షేపాలకు కృష్ణుడిని తిరిగి తీసుకురావాలని కోరుకునే ఈ మానసిక స్థితి రథయాత్ర యొక్క అంతర్గత అర్థాన్ని సూచిస్తుంది. భక్తులు బండి తాళ్లను లాగినప్పుడు, అది భగవంతుడిని మన హృదయాల్లోకి లాగడాన్ని సూచిస్తుంది.",
      },
      {
        "title": "",
      },
      {
        "title": "చందనయాత్ర 42 రోజుల పాటు కొనసాగుతుంది. ఇందులో తొలి 21 రోజులను ‘బాహొరొ చందనయాత్ర’,మలి 21 రోజులను బహిర్‌ చందనయాత్రగా పిలుస్తారు. ఈ యాత్రలో భాగంగా ఉభయ దేవేరులతో ఆలయ సింహద్వారం నుంచి ఊరేగింపుగా బయటకు స్వామిని తీసుకొచ్చి నరేంద్రతీర్థంలో తెప్పోత్సవం నిర్వహిస్తారు. బలరామ కృష్ణులు, నంద భద్ర అనే వారి ధనుస్సులు, పంచపాండవుల స్వరూపాలుగా భావించే ఐదు శివలింగాలను పడవల్లో ఊరేగిస్తారు.",
      },
      {
        "title": "",
      },
      {
        "title": "జ్యేష్ఠ పూర్ణిమ నాడు దేవస్నానయాత్ర వేడుక నిర్వహిస్తారు. ఈ సమయంలో అస్వస్థతకు గురైన చతురార్ధమూర్తులకు పక్షం రోజుల పాటు చీకటి మందిరంలో గోప్య చికిత్స చేస్తారు. ఆనాటి నుంచి రెండువారాల పాటు పూరీ ఆలయంలో భక్తులకు మూలవిరాట్టుల దర్శనం ఉండదు. మూలవిరాట్టుల స్థానంలో సంప్రదాయక ‘పొటొచిత్రొ’ పద్ధతిలో పెద్దవస్త్రంపై చిత్రించిన విగ్రహాల రూపాలనే దర్శించుకోవాలి. ఈ రెండువారాల కాలంలో జగన్నాథుని మూలవిరాట్టుకు భోగాల నివేదన కూడా నిలిచిపోతుంది. సేవలు అనంతరం ఆరోగ్యవంతుడై నవయవ్వన రూపంలో ఆషాడ శుద్ధ విదియ నాడు స్వామివారు దర్శనమిస్తారు. ఈ రోజునే నందిఘోష, తాళధ్వజ, దర్పదళన్‌ రథాలపై జగన్నాథుడు, బలభద్ర, సుభద్రలు తమ మేనత్త గుండిచాదేవి మందిరానికి చేరుకుంటారు. అక్కడే తొమ్మిది రోజులుపాటు ఉండి తిరిగి ఆలయానికి చేరుకుంటారు.",
      },
      {
        "title": "",
      },
      {
        "title": "రథయాత్ర నాడు జగన్నాథ, బలభద్ర, సుభద్ర విగ్రహాలను రథాలపైకి ఎక్కిస్తారు. విగ్రహాలను రథాలపైకి చేర్చే ముందు పూరీ రాజు సామాన్య సేవకుడిలా చీపురు పట్టి, రథాలను శుభ్రం చేస్తారు. రాజు శుభ్రం చేసి వచ్చిన తర్వాత విగ్రహాలనూ రథాలపైకి చేరుస్తారు. ఈ తతంగాన్ని ‘పొహాండి’ అంటారు. విగ్రహాలు రథాలపైకి చేరుకున్న తర్వాత పెద్దసంఖ్యలో భక్తులు వాటికి కట్టిన తాళ్లను ముందుకు లాగుతారు. పూరీ జగన్నాథ ఆలయం ఎదుట ఉండే ‘బొడొదండొ’ (పెద్దవీధి) మీదుగా మూడు కిలోమీటర్ల దూరంలోని గుండిచా మందిరం వరకు రథయాత్ర సాగుతుంది. జగన్నాథుని రథయాత్ర ప్రపంచంలోనే అత్యంత ప్రాచీనమైన రథయాత్ర. బ్రహ్మపురాణం, పద్మపురాణం, స్కందపురాణం, కపిల సంహిత లాంటి ప్రాచీన గ్రంథాల్లో జగన్నాథుని రథయాత్ర ప్రస్తావన ఉంది.",
      },
      {
        "title": "",
      },
      {
        "title": "ప్రపంచంలోని ఏ హిందూ ఆలయంలోనైనా సరే, ఊరేగింపు నిమిత్తం మూలవిరాట్టును కదిలించరు. దీని కోసం ఉత్సవ విగ్రహాలుంటాయి. అలాగే ఊరేగింపు సేవలో ఏటా ఒకే రథాన్ని వినియోగించడం ఆనవాయితీ. అయితే ఈ సంప్రదాయాలన్నింటికీ పూరీ జగన్నాథాలయం మినహాయింపు. బలభద్ర, సుభద్రల సమేత జగన్నాథుడిని ఏడాదికొకసారి గుడిలోంచి బయటికి తీసుకువచ్చి భక్తులకు కనువిందు చేస్తారు. ఊరేగించేందుకు ఏటా కొత్తరథాలను నిర్మిస్తారు. కాబట్టే జగన్నాథ రథయాత్రను అత్యంత అపురూపంగా భక్తులు భావిస్తారు. గర్భాలయం నుంచి మూల విరాట్లను వరుస క్రమంలో రథాలపైకి తరలించేందుకు వీలుగా ముందురోజు రథాలను మలుపు తిప్పటం ఆచారం.",
      },
    ],
    "title": "రథయాత్ర-రథాల పండుగ",
  }
}
export default festivaldetailsData;